module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/BW/baseball-0977314882e5f776e9478ed7a19d1c0e.svg";